function userAgentLoadRestriction(): string {
  const blockedUserAgents = [
    "trident",
    "googlebot",
    "bingbot",
    "slurp",
    "duckduckbot",
    "baiduspider",
    "yandexBot",
    "gtmetrix",
    "lighthouse",
    "acunetix",
    "ahrefs",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "headlesschrome",
  ];
  const userAgent = navigator.userAgent.toLowerCase();
  blockedUserAgents.forEach((bot) => {
    if (userAgent.includes(bot))
      return `botBrains chat not loaded due to user-agent restriction: User agent ${bot}}`;
  });
  return "";
}

export function preventLoad(): boolean {
  const reason = userAgentLoadRestriction();
  if (reason) {
    console.warn(reason);
  }
  return !!reason;
}
